import React, { useState, useEffect } from 'react';
import { getAllSportsData } from '../axios-services';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import Home from './SportsPages/Home';
import Baseball from './SportsPages/Baseball';
import Basketball from './SportsPages/Basketball';
import Football from './SportsPages/Football';
import Golf from './SportsPages/Golf';
import Soccer from './SportsPages/Soccer';
// import Tennis from './SportsPages/Tennis';




import '../style/App.css';
import NavBar from './NavBar/NavBar';

const App = () => {
  const [allSports, setAllSports] = useState([]);
  const [allSportsGroups, setAllSportsGroups] = useState([]);


  useEffect(() => {
    const getAllSports = async () => {
      const sports = await getAllSportsData();
      setAllSports(sports);
      const groups = {};
      sports.map(sport => groups[sport.group] = sport.group)
      setAllSportsGroups(Object.keys(groups))
    }
    getAllSports();
  }, []);



  return (
    <div className="app-container">
      <Router>
      <Link to='/' className='appTitle'>BC SportsLive</Link>
        <NavBar allSportsGroups={allSportsGroups} />
        <Switch>
          <Route exact path='/'>
            <Home />
          </Route>
          <Route path='/Baseball' >
            <Baseball allSports={allSports} />
          </Route>
          <Route path='/Basketball'>
            <Basketball allSports={allSports} />
          </Route>
          <Route path='/American Football' >
            <Football allSports={allSports} />
          </Route>
          <Route path='/Soccer' >
            <Soccer allSports={allSports} />
          </Route>
          <Route path='/Golf' >
            <Golf allSports={allSports} />
          </Route>
          {/* <Route path='/Tennis' component={Tennis} /> */}
        </Switch>
      </Router>
    </div>
  );
};

export default App;
